import { render, staticRenderFns } from "./VehiculoPivotTable.vue?vue&type=template&id=1da2f907"
import script from "./VehiculoPivotTable.vue?vue&type=script&lang=js"
export * from "./VehiculoPivotTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports